import React from 'react';
import {
  getHeroContent, HeroImage, StoreLogo, CartBtn, TabContent, StoreFooter, FaHeart, MdSearch, getTabLabel, InlineEditableText
} from './ThemeLayoutHelpers';

export default function EmpireLayout({ p }) {
  const T = p.storeTheme || {};
  const primary = T.primaryColor || "#4f46e5";
  const text = p.storefrontText || {};
  const copy = getHeroContent(p, {
    eyebrow: "Empire • Premium",
    title: "Luxury. Curated. Yours.",
    subtitle: "Premium brands and exclusive picks selected for the discerning buyer.",
    primaryCta: "Explore Collection",
    secondaryCta: "Our Story",
  });
  return (
    <div className="min-h-screen flex flex-col bg-[#07071a] text-white" style={{ fontFamily: T.fontFamily || "Montserrat, sans-serif" }}>
      <nav className="sticky top-0 z-40 border-b border-white/8 bg-black/75 backdrop-blur-2xl">
        <div className="max-w-7xl mx-auto px-5 py-3.5 flex items-center gap-4">
          <StoreLogo storeInfo={p.storeInfo} border="border-2 border-white/20" />
          <span className="font-extrabold tracking-[0.14em] uppercase text-sm text-white/90">{p.storeInfo?.businessName}</span>
          <div className="hidden md:flex ml-4 flex-1 relative max-w-xs">
            <MdSearch className="absolute left-3 top-2.5 text-slate-400 text-lg" />
            <input
              value={p.searchQuery}
              onChange={e => p.setSearchQuery(e.target.value)}
              placeholder={text.searchProducts || "Search products"}
              className="w-full py-2 pl-10 pr-4 rounded-xl bg-slate-900/90 border border-slate-700 text-slate-100 text-sm placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-indigo-400"
            />
          </div>
          <div className="ml-auto flex items-center gap-2.5">
            <button onClick={p.handleGoToWishlist} className="relative p-2.5 rounded-xl border border-white/15 hover:bg-white/10">
              <FaHeart className="text-base text-white/70" />
              {p.wishlistCount > 0 && <span className="absolute -top-1 -right-1 h-4 w-4 text-[9px] rounded-full bg-indigo-500 text-white flex items-center justify-center">{p.wishlistCount}</span>}
            </button>
            <CartBtn p={p} dark />
            {p.userMenuElement}
          </div>
        </div>
      </nav>
      <section className="relative h-[68vh] min-h-[480px] overflow-hidden">
        <HeroImage p={p} themeId="empire" className="h-full">
          <div className="absolute inset-0 bg-gradient-to-t from-[#07071a] via-black/55 to-black/20 pointer-events-none" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#07071a]/90 via-transparent to-transparent pointer-events-none" />
        </HeroImage>
        <div className="absolute inset-0 max-w-7xl mx-auto px-6 flex flex-col justify-end pb-14">
          <span className="text-[10px] uppercase tracking-[0.35em] text-indigo-300/70 font-semibold"><InlineEditableText p={p} field="heroEyebrow" value={copy.eyebrow}>{copy.eyebrow}</InlineEditableText></span>
          <h1 className="mt-3 text-5xl md:text-6xl font-extrabold text-white leading-none tracking-tight max-w-2xl"><InlineEditableText p={p} field="heroTitle" value={copy.title}>{copy.title}</InlineEditableText></h1>
          <p className="mt-4 text-white/55 max-w-md text-sm leading-relaxed"><InlineEditableText p={p} field="heroSubtitle" value={copy.subtitle}>{copy.subtitle}</InlineEditableText></p>
          <div className="mt-7 flex gap-4">
            <button onClick={() => p.setActiveTab("products")} className="px-8 py-3.5 rounded-xl text-sm font-bold tracking-wide text-white shadow-lg" style={{ backgroundColor: primary }}><InlineEditableText p={p} field="primaryCtaText" value={copy.primaryCta}>{copy.primaryCta}</InlineEditableText></button>
            <button onClick={() => p.setActiveTab("details")} className="px-8 py-3.5 rounded-xl text-sm font-semibold text-white/70 border border-white/20 hover:bg-white/8"><InlineEditableText p={p} field="secondaryCtaText" value={copy.secondaryCta}>{copy.secondaryCta}</InlineEditableText></button>
          </div>
        </div>
      </section>
      <div className="max-w-7xl mx-auto w-full px-5 py-4">
        <div className="flex gap-2 border-b border-white/10 pb-1">
          {[["products", getTabLabel(p, "products", "shop")],["services", getTabLabel(p, "services")],["details", getTabLabel(p, "details")]].map(([k,l]) => (
            <button key={k} onClick={() => p.setActiveTab(k)} className="px-5 py-2.5 text-sm font-semibold transition" style={p.activeTab===k ? { color:"#fff", borderBottom:`2px solid ${primary}` } : { color:"rgba(255,255,255,0.45)" }}>{l}</button>
          ))}
        </div>
      </div>
      <section className="flex-1 max-w-7xl mx-auto w-full px-5 pb-14"><TabContent p={p} dark /></section>
      <StoreFooter p={p} dark />
    </div>
  );
}

// ─── Bloom ───────────────────────────────────────────────────────────────────